import React, {MouseEventHandler} from "react";
import pptMarker from "../../assets/icon/ic_ppt_marker.svg";
import pptMarkerActive from "../../assets/icon/ic_ppt_marker_active.svg";
import styled from "styled-components";

// left: \`calc(${percentage}% - 1.125em)\`;
// color: visiblePage ? 'white' : '#5F5CFE',

const StyledMarker = styled.div`
    position: absolute;
    display: inline-block;
    // left: calc(${(props) => (props as any)['data-percentage']}% - 1.125em);
    // top: -3em;
    // top: -0.5em;
    // height: 3em;
    // width: 2.25em;
    left: calc(${(props) => (props as any)['data-percentage']}% - 15.5px);
    top: -42px;
    width: 31px;
    height: 42px;
    // left: -13.5px;
    z-index: 2;
    cursor: pointer;
    
    img {
        position: absolute;
        pointer-events: none;
        left: -13.5px;
        top: -13.5px;
    }
    
    div {
        text-align: center;
        position: absolute;
        font-weight: bold;
        height: 100%;
        font: Bold 18px/28px Noto Sans KR;
        color: ${(props) => (props as any)['data-visible'] ? 'white' : '#5F5CFE'};
        line-height: 1.5em;
        width: 100%;
        pointer-events: none;
    }
    
    ${(props) => (props as any)['data-visible'] ? `
        z-index: 90;
    ` : ''};
    
    :hover {
        z-index: 100;
        transform: translateY(-10px);
        img {
            content: url('${pptMarkerActive}');
        }
        
        div {
                color: white;
        }
    }
`;

interface ISlideMarker {
    className?: string,
    percentage: number,
    visible: boolean,
    context: string,
    onClick: MouseEventHandler<HTMLDivElement>
}

const SlideMarker: React.FC<ISlideMarker> = (({
                                                  className,
                                                  percentage,
                                                  visible,
                                                  context,
                                                  onClick
                                              }) => {
    return (
        <StyledMarker className={className} data-percentage={percentage} data-visible={visible} onClick={onClick}>
            <img src={visible ? pptMarkerActive : pptMarker} alt=""/>
            <div>
                {context}
            </div>
        </StyledMarker>
    )
});

export default SlideMarker;